import Reveal from "./Reveal";

const highlights = [
  "Threat monitoring",
  "Endpoint protection",
  "Security assessments",
  "Data protection",
  "Ransomware preparedness",
  "Employee security awareness",
  "Backup and recovery",
];

export default function Cybersecurity() {
  return (
    <section
      id="security"
      className="relative py-20 md:py-28 bg-foreground-950 overflow-hidden scroll-mt-20"
    >
      {/* animated network grid */}
      <div
        className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(oklch(var(--primary-500) / 0.5) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--primary-500) / 0.5) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="absolute top-1/4 right-10 w-80 h-80 rounded-full bg-primary-500/15 blur-3xl animate-pulse-glow pointer-events-none" />
      <div className="absolute bottom-1/4 left-10 w-72 h-72 rounded-full bg-accent-400/10 blur-3xl animate-pulse-glow pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-300">
              Cybersecurity
            </span>
            <h2 className="mt-3 font-heading font-extrabold text-white text-3xl md:text-4xl tracking-tight">
              Stay Ahead of Cyber Threats
            </h2>
            <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed">
              Cyber threats are constantly evolving. Your security strategy should too. We help
              businesses protect their systems, data, employees, and customers with proactive
              cybersecurity solutions.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {highlights.map((h) => (
                <div key={h} className="flex items-center gap-2.5 text-white/80 text-sm">
                  <span className="w-6 h-6 shrink-0 rounded-full bg-accent-500/20 text-accent-300 flex items-center justify-center">
                    <i className="ri-check-line text-sm" />
                  </span>
                  {h}
                </div>
              ))}
            </div>

            <div className="mt-9">
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-white px-7 py-3.5 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                Talk to a Security Expert
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </Reveal>

          {/* Shield visual */}
          <Reveal delay={100}>
            <div className="relative flex items-center justify-center">
              <div className="relative w-64 h-64 md:w-80 md:h-80">
                <div className="absolute inset-0 rounded-full border border-primary-500/30 animate-spin-slow" />
                <div className="absolute inset-8 rounded-full border border-accent-400/20" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-gradient-to-br from-primary-500/20 to-accent-400/20 border border-white/10 backdrop-blur-sm flex items-center justify-center">
                    <i className="ri-shield-check-line text-white/90 text-6xl md:text-7xl" />
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}